import { FC, memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SummaryBigText, SummaryInner, SummaryLine, SummaryPart, SummaryPrice, SummaryTotalText } from './styles'
import { SummaryInfoList } from './SummaryInfoList'
import { getCurrencyIcon, getFormattedCurrency, isCompositeCurrency } from '../CheckOut/helpers/utils'
import { PaymentCurrency } from "../../constants/types";
import { CurrencyType } from '@brg/api'
import { useCurrency } from '../../hooks/useCurrency'

interface OrderSummaryProps {
    paymentCurrency?: PaymentCurrency,
    paymentSuccess?: boolean
}

export const OrderSummary: FC<OrderSummaryProps> = memo(({ paymentCurrency, paymentSuccess }) => {
    const { t } = useTranslation()
    const { formatValue } = useCurrency()

    const rubIcon = getCurrencyIcon({ currencyType: CurrencyType.RUB, isWhite: false })
    const playMoneyIcon = getCurrencyIcon({ currencyType: CurrencyType.PlayMoney, isWhite: false}) 
    const realMoneyIcon = getCurrencyIcon({ currencyType: CurrencyType.RealMoney, isWhite: false})

    const ComplexTotalComponent = useMemo(() => {
        const currentTypeCurrency = paymentCurrency
        if (!currentTypeCurrency) return 
        if (!isCompositeCurrency(currentTypeCurrency)) {
            return <SummaryTotalText>
                <SummaryPart>
                    {formatValue(currentTypeCurrency?.amount || 0)} {getCurrencyIcon({ currencyType: currentTypeCurrency?.currencyType, isWhite: false })}
                </SummaryPart>
            </SummaryTotalText>
        }
        const { v: rubPart } = getFormattedCurrency({ currency: currentTypeCurrency, formatValue, currencyType: CurrencyType.RUB })
        const { v: playPart } = getFormattedCurrency({ currency: currentTypeCurrency, formatValue, currencyType: CurrencyType.PlayMoney }) 
        const { v: realPart } = getFormattedCurrency({ currency: currentTypeCurrency, formatValue, currencyType: CurrencyType.RealMoney }) 
        return <SummaryTotalText>
            {rubPart && <SummaryPart>{rubPart} {rubIcon}</SummaryPart>}
            {playPart && <SummaryPart>{playPart} {playMoneyIcon}</SummaryPart>}
            {realPart && <SummaryPart>{realPart} {realMoneyIcon}</SummaryPart>}
        </SummaryTotalText> 
    }, [paymentCurrency, rubIcon, playMoneyIcon, realMoneyIcon, formatValue])

    if (paymentSuccess) return (
        <SummaryInner isGift={true} isSuccessfulOrder={paymentSuccess}>
            <SummaryInfoList paymentCurrency={paymentCurrency} paymentSuccess={paymentSuccess} offsetBottom={0} offsetTop={0} />
        </SummaryInner>
    )

    return (
        <SummaryInner isGift={true} isWhiteBg={true}>
            <SummaryBigText>
                {t("payment.summary")}
            </SummaryBigText>
            <SummaryInfoList/>
            <SummaryLine />
            <SummaryPrice>
                <SummaryTotalText>{t("payment.total")}</SummaryTotalText>
                {
                    !paymentCurrency ? <></> : <SummaryTotalText>{ComplexTotalComponent}</SummaryTotalText>
                }
            </SummaryPrice>
        </SummaryInner>
    )
})
import { FC, memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SummaryBigText, SummaryInner, SummaryLine, SummaryPart, SummaryPrice, SummaryTotalText } from './styles'
import { SummaryInfoList } from './SummaryInfoList'
import { getCurrencyIcon, getFormattedCurrency, isCompositeCurrency } from '../CheckOut/helpers/utils'
import { PaymentCurrency } from "../../constants/types";
import { CurrencyType } from '@brg/api'
import { useCurrency } from '../../hooks/useCurrency'

interface OrderSummaryProps {
    paymentCurrency?: PaymentCurrency,
    paymentSuccess?: boolean
}

export const OrderSummary: FC<OrderSummaryProps> = memo(({ paymentCurrency, paymentSuccess }) => {
    const { t } = useTranslation()
    const { formatValue } = useCurrency()

    const rubIcon = getCurrencyIcon({ currencyType: CurrencyType.RUB, isWhite: false })
    const playMoneyIcon = getCurrencyIcon({ currencyType: CurrencyType.PlayMoney, isWhite: false}) 
    const realMoneyIcon = getCurrencyIcon({ currencyType: CurrencyType.RealMoney, isWhite: false})

    const ComplexTotalComponent = useMemo(() => {
        const currentTypeCurrency = paymentCurrency
        if (!currentTypeCurrency) return 
        if (!isCompositeCurrency(currentTypeCurrency)) {
            return <SummaryTotalText>
                <SummaryPart>
                    {formatValue(currentTypeCurrency?.amount || 0)} {getCurrencyIcon({ currencyType: currentTypeCurrency?.currencyType, isWhite: false })}
                </SummaryPart>
            </SummaryTotalText>
        }
        const { v: rubPart } = getFormattedCurrency({ currency: currentTypeCurrency, formatValue, currencyType: CurrencyType.RUB })
        const { v: playPart } = getFormattedCurrency({ currency: currentTypeCurrency, formatValue, currencyType: CurrencyType.PlayMoney }) 
        const { v: realPart } = getFormattedCurrency({ currency: currentTypeCurrency, formatValue, currencyType: CurrencyType.RealMoney }) 
        return <SummaryTotalText>
            {rubPart && <SummaryPart>{rubPart} {rubIcon}</SummaryPart>}
            {playPart && <SummaryPart>{playPart} {playMoneyIcon}</SummaryPart>}
            {realPart && <SummaryPart>{realPart} {realMoneyIcon}</SummaryPart>}
        </SummaryTotalText> 
    }, [paymentCurrency, rubIcon, playMoneyIcon, realMoneyIcon, formatValue])

    if (paymentSuccess) return (
        <SummaryInner isGift={true} isSuccessfulOrder={paymentSuccess}>
            <SummaryInfoList paymentCurrency={paymentCurrency} paymentSuccess={paymentSuccess} offsetBottom={0} offsetTop={0} />
        </SummaryInner>
    )

    return (
        <SummaryInner isGift={true} isWhiteBg={true}>
            <SummaryBigText>
                {t("payment.summary")}
            </SummaryBigText>
            <SummaryInfoList/>
            <SummaryLine />
            <SummaryPrice>
                <SummaryTotalText>{t("payment.total")}</SummaryTotalText>
                {
                    !paymentCurrency ? <></> : <SummaryTotalText>{ComplexTotalComponent}</SummaryTotalText>
                }
            </SummaryPrice>
        </SummaryInner>
    )
})
